import { useState, useEffect, useCallback, useRef } from "react";
import { useParams } from "react-router-dom";
import { BrandDetails as BrandDetailsType } from "../types/add-brand-types";
import useBrandDetailsApi from "../api/useBrandDetailsApi";
import { useNavigation } from "./useNavigation";

const useBrandDetails = () => {
  const navigate = useNavigation();
  const { getBrandDetails } = useBrandDetailsApi();
  const { id } = useParams<{ id: string }>();
  const [activeTab, setActiveTab] = useState("strategy");
  const [loading, setLoading] = useState(!!id);

  const [brandDetails, setBrandDetails] = useState<
    BrandDetailsType | undefined
  >(undefined);

  const idRef = useRef(id);
  idRef.current = id;

  const refreshBrandDetails = useCallback(async () => {
    const targetId = idRef.current;
    if (targetId) {
      setLoading(true);
      try {
        const details = await getBrandDetails(targetId);
        if (details) {
          setBrandDetails(details.data);
        }
      } catch (error) {
        console.error("Failed to refresh brand details", error);
      } finally {
        setLoading(false);
      }
    }
  }, [getBrandDetails]);

  useEffect(() => {
    if (id) {
      refreshBrandDetails();
    }
  }, [id, refreshBrandDetails]);

  return {
    activeTab,
    setActiveTab,
    navigate,
    brandFromState: brandDetails, // Return the state managed brandDetails
    refreshBrandDetails,
    loading,
  };
};

export default useBrandDetails;
